// extracted by mini-css-extract-plugin
module.exports =  {"root":"ep4magGZWOKAQqW9gaVw"};